import {Injectable, signal, WritableSignal} from '@angular/core';
import {Subject} from 'rxjs';
import {CommentEntityType} from '../../../api/interfaces/comment';

@Injectable({
  providedIn: 'root'
})
export class CommentsStateManager {
  private commentsChangeSignal: WritableSignal<{ elementId: string, commentsCount: number } | null> = signal(null);
  private firstCommentAddedSignal: WritableSignal<{
    elementId: string,
    elementType: CommentEntityType,
    timestamp: number
  } | null> = signal(null);
  private noCommentsSignal: WritableSignal<{ elementId: string, timestamp: number } | null> = signal(null);
  private draftOwners = new Set<object>();
  private lastDraftNudge = Number.NEGATIVE_INFINITY;
  readonly draftActive = signal(false);
  readonly draftNudge$ = new Subject<void>();

  setDraftActive(owner: object, active: boolean) {
    if (active) {
      this.draftOwners.add(owner);
    } else {
      this.draftOwners.delete(owner);
    }
    this.draftActive.set(this.draftOwners.size > 0);
  }

  nudgeDraft(now = Date.now()): boolean {
    if (!this.draftActive() || now - this.lastDraftNudge < 400) return false;
    this.lastDraftNudge = now;
    this.draftNudge$.next();
    return true;
  }

  triggerCommentsChange(elementId: string, commentsCount: number) {
    this.commentsChangeSignal.set({ elementId, commentsCount });
  }

  getCommentsChange() {
    return this.commentsChangeSignal();
  }

  triggerFirstCommentAdded(params: {elementId: string, elementType: CommentEntityType}) {
    this.firstCommentAddedSignal.set({...params, timestamp: Date.now()});
  }

  getFirstCommentAdded(): { elementId: string, elementType: CommentEntityType } | null {
    const value = this.firstCommentAddedSignal();
    if (!value) return null;
    return {elementId: value.elementId, elementType: value.elementType};
  }

  triggerNoComments(elementId: string) {
    this.noCommentsSignal.set({elementId, timestamp: Date.now()});
  }

  getNoComments(): string | null {
    return this.noCommentsSignal()?.elementId ?? null;
  }

}
